import { render, staticRenderFns } from "./ReservierungDetails.vue?vue&type=template&id=1fb69da8"
import script from "./ReservierungDetails.vue?vue&type=script&lang=ts"
export * from "./ReservierungDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports